export default "__VITE_ASSET__q9y4zefW__"